import React from 'react'
import PropTypes from 'prop-types'
import ProfileLanguageFlag from '../app_components/ProfileLanguageFlag'
import StandardButton from '../app_components/StandardButton'
import { getLanguageLevelLabel } from '../connect_sections/connectMemberHelpers'

class DashboardLanguageField extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      languageChoices: [],
      openPicker: false,
      newLanguage: null,
      saving: false,
      searchValue: '',
    }

    this.openPicker = this.openPicker.bind(this)
    this.selectLanguage = this.selectLanguage.bind(this)
    this.saveLanguage = this.saveLanguage.bind(this)
  }

  componentDidMount() {
    $.ajax({
      url: '../ajaxGetLanguages',
      dataType: 'JSON',
      type: 'GET',
      success: (data) => {
        this.setState({
          languageChoices: data.data.allLanguages || [],
        })
      },
    })
  }

  openPicker() {
    this.setState({ openPicker: true, newLanguage: null, searchValue: '' })
  }

  selectLanguage(language) {
    this.setState({ newLanguage: language })
  }

  saveLanguage(level) {
    const { newLanguage } = this.state
    if (!newLanguage) return

    this.setState({ saving: true })

    $.ajax({
      url: '../ajaxCreateLanguagesUser',
      dataType: 'JSON',
      type: 'POST',
      data: {
        level,
        language_id: newLanguage.id,
      },
      success: () => {
        this.setState({
          openPicker: false,
          newLanguage: null,
          saving: false,
        })
        if (this.props.onUpdated) {
          this.props.onUpdated()
        }
      },
      error: () => {
        this.setState({ saving: false })
      },
    })
  }

  filteredLanguages() {
    const search = this.state.searchValue.trim().toLowerCase()
    const choices = this.state.languageChoices.filter((language) => language.primary === true)

    if (!search) return choices.slice(0, 8)

    return choices.filter((language) => (
      language.language.toLowerCase().includes(search)
      || (language.native && language.native.toLowerCase().includes(search))
    )).slice(0, 8)
  }

  renderLevelOptions() {
    const levels = this.props.nativeOnly ? [5] : [4, 3, 2, 1]

    return (
      <div className="dashboardProfileField__levelOptions">
        {levels.map((level) => (
          <button
            key={level}
            type="button"
            className={`dashboardProfileField__levelBtn language_level language_level${level}`}
            onClick={() => this.saveLanguage(level)}
            disabled={this.state.saving}
          >
            {getLanguageLevelLabel(level)}
          </button>
        ))}
      </div>
    )
  }

  render() {
    const { label, description } = this.props

    return (
      <div className="dashboardProfileField">
        <div className="dashboardProfileField__copy">
          <p className="dashboardProfileField__label">{label}</p>
          <p className="dashboardProfileField__description">{description}</p>
        </div>

        {!this.state.openPicker && (
          <StandardButton
            text="Add language"
            size="small"
            primary={false}
            onClick={this.openPicker}
          />
        )}

        {this.state.openPicker && !this.state.newLanguage && (
          <div className="dashboardProfileField__picker">
            <input
              className="dashboardProfileField__search"
              value={this.state.searchValue}
              onChange={(event) => this.setState({ searchValue: event.target.value })}
              placeholder="Search languages"
            />
            <div className="dashboardProfileField__languageList">
              {this.filteredLanguages().map((language) => (
                <button
                  key={language.id}
                  type="button"
                  className="dashboardProfileField__languageOption"
                  onClick={() => this.selectLanguage(language)}
                >
                  <ProfileLanguageFlag flagHtml={language.flag_html} />
                  <span>{language.language}</span>
                </button>
              ))}
            </div>
          </div>
        )}

        {this.state.newLanguage && (
          <div className="dashboardProfileField__picker">
            <p className="dashboardProfileField__selectedLanguage">
              {this.state.newLanguage.language}
            </p>
            <p className="dashboardProfileField__description">
              {this.props.nativeOnly
                ? 'Choose your fluency level for this language.'
                : 'How well do you speak this language?'}
            </p>
            {this.renderLevelOptions()}
          </div>
        )}
      </div>
    )
  }
}

DashboardLanguageField.propTypes = {
  label: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  nativeOnly: PropTypes.bool,
  onUpdated: PropTypes.func,
}

DashboardLanguageField.defaultProps = {
  nativeOnly: false,
}

export default DashboardLanguageField
